import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { createSlice } from '@reduxjs/toolkit'
import { mapValues } from 'lodash-es'
import API from 'state/API'
import { useObjSelector } from 'utils'
import Account from './models/Account'

const slice = createSlice({
	name        : 'account',
	initialState: {
		previous: '',
		current : {},
	},
	reducers    : {
		setAccount  : (state, { payload: account }) => {
			state.current = account
		},
		mergeAccount: (state, { payload }) => {
			Object.assign(state.current, payload)
		},
		clearAccount: state => ({
			previous: state.current.id_string,
			current : {},
		}),
	},
})

//not exactly official, but enough for some organization
slice.thunks = {
	refreshAccount: async dispatch => {
		const account = (await API.get('account')).data
		await dispatch(slice.actions.setAccount(account))
	},
	refreshChatDetails: async dispatch => {
		const chat = (await API.get('auth/chat_platform')).data || false
		await dispatch(slice.actions.mergeAccount({ chat }))
	},
	toggleShipday: async dispatch => {
		const result = (await API.patch(`account/toggle_shipday`)).data
		dispatch(slice.actions.mergeAccount({ shipday_enabled_status: result }))
	}
}

//TODO: turn getAccount into useAccount with those shenanigans
export const getPreviousAccount = ({ account }) => account.previous
export const getAccount         = ({ account }) => new Account(account.current)
/** @return Account */
export const useAccount         = () => useObjSelector(getAccount)

/**
 * Interprets the icon syntax used and returns the complete icon element + title
 * @param account
 * @return {{ icon: React.Element, title: string, subject: string, body: string }}
 */
export const getCannedMessages = ({ account }) => {
	const baseList = account.current.canned_messages || {}

	return mapValues(baseList, ({ icon, ...props }) => {
		let [, ban, pureIcon] = icon.match(/^(!)?(.*)/)

		icon = ban?
			<span className="fa-layers fa-fw">
				<FontAwesomeIcon icon={pureIcon} className="text-muted"/>
				<FontAwesomeIcon icon="slash"/>
			</span>
			:
			<FontAwesomeIcon icon={pureIcon} fixedWidth/>

		return { icon, ...props }
	})
}

/**
 * @param state
 * @return {{plural: string, singular: string}}
 */
export const getLocationWords = state => {
	const account = getAccount(state)
	return {
		singular: account.location_wording_singular,
		plural  : account.location_wording_plural,
	}
}

export const { setAccount, clearAccount } = slice.actions
export const { refreshAccount, refreshChatDetails, toggleShipday } = slice.thunks

export default slice.reducer
